export * from "-!../../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./transactions.vue?vue&type=template&id=1fe565c5"


//////////////////
// WEBPACK FOOTER
// ./skins/bulmasite/components/pages/sitepages/history/transactions.vue?vue&type=template&id=1fe565c5
// module id = 0pG9
// module chunks = 0